export default "// Pull in module dependencies.\nconst fire = require(\"fire\");\n\n// the left mouse button.\nwhile (true) {\n  new fire({ aim: true });\n}\n";